/* istanbul ignore file */
(function () {
    // meet the true enemy ... browser support :D
    var passiveEvent = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            get: function () {
                passiveEvent = true;
            }
        });
        window.addEventListener("test", function () { }, opts);
    }
    catch (e) { }
    passiveEvent = passiveEvent ? { capture: true, passive: true } : true;
}());
function sbFindIframeContentWindow(s) {
    var iframe;
    var f = document.getElementsByTagName("iframe");
    iframe = Array.prototype.filter.call(f, function (x) { return x.src.match(s); })[0];
    linkedFrames.push(iframe);
    var contentWindow = iframe && iframe.contentWindow;
    return contentWindow;
}
function sbRemoveFromList(list, item) {
    var i = list.indexOf(item);
    i > -1 && list.splice(i, 1);
}
function cacheMaintainer(t, m) { messagesCache[t] = m; }
function garbageColletor() {
    if (window["sbMsgBus"]) {
        var b_1 = window["sbMsgBus"];
        Object.keys(b_1.topics).forEach(function (x) {
            if (b_1.topics[x].length === 0) {
                delete b_1.topics[x];
                delete messagesCache[x];
            }
        });
    }
}
function initGC() {
    garbageColletor();
    setTimeout(initGC, 10000);
}
setTimeout(initGC, 10000);
var messagesCache = {};
// nulled on deactivate - needs to be VAR
var linkedFrames = [];
var linkedWindows = [];
var internalPrefix = "sb-mbus-";
var sbPrefix = "sb_";
// !!! IMPORTANT
// -> window.opener is not consistent between web browsers!
/**
 * SBMsgBus
 * Establishes a way for our application to communicate between iframes and windows created by window.open(...)
 */
var SBMsgBusClass = /** @class */ (function () {
    function SBMsgBusClass() {
        this.sbPrefix = sbPrefix;
        this.type = "parent";
        this.isActive = false;
        // tslint:disable-next-line
        this.topics = Object.create(null);
        this.receiveMessages = this.receiveMessages.bind(this);
        this.deactivate = this.deactivate.bind(this);
        this.activate();
    }
    SBMsgBusClass.prototype.activate = function () {
        this.isActive = true;
        this.type = "parent";
        if ((window.opener !== null && window.opener !== undefined) || window.parent !== window) {
            this.initAsChild();
        }
        window.addEventListener("onunload", this.deactivate, true);
        window.addEventListener("message", this.receiveMessages, true);
        this.link(window);
        return this;
    };
    SBMsgBusClass.prototype.deactivate = function () {
        this.isActive = false;
        // tslint:disable-next-line
        this.topics = Object.create(null);
        this.post({ "sb-mbus-unlink": window.location.toString() });
        linkedFrames = [];
        linkedWindows = [];
        window.removeEventListener("onunload", this.deactivate, true);
        window.removeEventListener("message", this.receiveMessages, true);
        this.unlink(window); // unlink self for messages
        return this;
    };
    SBMsgBusClass.prototype.initAsChild = function () {
        this.type = "child";
        this.link((window.opener === null || window.opener === undefined) ? window.parent : window.opener);
        this.post({ "sb-mbus-link": window.location.origin.toString() });
        return this;
    };
    /* tslint:disable:cyclomatic-complexity */
    SBMsgBusClass.prototype.link = function (s) {
        if (!this.isActive) {
            return this;
        }
        var sibling;
        if (typeof s === "string") {
            sibling = sbFindIframeContentWindow(s);
        }
        //For some reason in IE postMessage is object
        if (typeof s === "object" && (typeof s["postMessage"] === "function" || typeof s["postMessage"] === "object")) {
            sibling = s;
        }
        if (sibling) {
            linkedWindows.indexOf(sibling) === -1 && linkedWindows.push(sibling);
        }
        return this;
    };
    SBMsgBusClass.prototype.unlink = function (s) {
        if (!this.isActive) {
            return this;
        }
        var sibling;
        if (typeof s === "string") {
            sibling = sbFindIframeContentWindow(s);
        }
        //For some reason in IE postMessage is object
        if (typeof s === "object" && (typeof s["postMessage"] === "function" || typeof s["postMessage"] === "object")) {
            sibling = s;
        }
        if (sibling) {
            sbRemoveFromList(linkedWindows, sibling);
        }
        return this;
    };
    /* tslint:enable:cyclomatic-complexity */
    SBMsgBusClass.prototype.receiveMessages = function (e) {
        var m;
        try {
            m = JSON.parse(e.data);
        }
        catch (err) {
            m = undefined;
        }
        m && this.routeMessages(m);
        return this;
    };
    SBMsgBusClass.prototype.routeMessages = function (m) {
        var _this = this;
        if (m) {
            Object.keys(m).forEach(function (x) {
                if (x.match(internalPrefix)) {
                    try {
                        _this[x.replace(internalPrefix, "")](m[x]);
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
                else if (x.match(sbPrefix)) {
                    if (Array.isArray(_this.topics[x])) {
                        _this.topics[x].forEach(function (y) {
                            if (typeof y === "function") {
                                setTimeout(function () {
                                    try {
                                        y(m[x]);
                                    }
                                    catch (err) {
                                        console.error(err);
                                    }
                                });
                            }
                        });
                    }
                    cacheMaintainer(x, m[x]);
                }
            });
        }
        return this;
    };
    SBMsgBusClass.prototype.subscribe = function (t, c) {
        if (typeof this.topics[t] === "undefined") {
            this.topics[t] = [];
        }
        this.topics[t].indexOf(c) === -1 && this.topics[t].push(c);
        if (typeof messagesCache[t] !== "undefined") {
            c(messagesCache[t]);
        }
    };
    SBMsgBusClass.prototype.unsubscribe = function (t, c) {
        if (Array.isArray(this.topics[t])) {
            sbRemoveFromList(this.topics[t], c);
        }
    };
    SBMsgBusClass.prototype.post = function (m) {
        var s;
        try {
            s = JSON.stringify(m);
        }
        catch (err) {
            s = "";
            console.error("Tried to send malformed message: " + m + ", err > " + err);
        }
        linkedWindows.forEach(function (x) {
            if (typeof x !== "undefined" && (typeof x.postMessage === "function" || typeof x["postMessage"] === "object")) {
                try {
                    x.postMessage(s, "*");
                }
                catch (err) {
                    console.error(err);
                }
            }
        });
        return this;
    };
    return SBMsgBusClass;
}());
export { SBMsgBusClass };
export var sbMsgBusInstance = window["sbMsgBus"] || new SBMsgBusClass();
//# sourceMappingURL=mbus.js.map